import { SharedSettings } from '../settings/SharedSettings'

export const setToken = (token: string) => {
  localStorage.setItem(SharedSettings.LOCAL_STORAGE_KEYS.AUTH_TOKEN, token)
}
